@use '@design/design-tokens/typography/typography' as *;

.emptyPortfolioWrapper {
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  padding: 64px 35px;
  height: 100%;
}

.styledImg {
  align-self: center;
  margin-bottom: 8px;
}

.title {
  font-size: 1.063rem;
  line-height: 1.5rem;
  font-weight: 500;
  margin-bottom: 4px;

  @media screen and (min-width: 1040px) {
    font-size: 1rem;
  }
}

.description {
  font-size: 0.938rem;
  line-height: 1.25rem;
  font-weight: 400;
  max-width: 366px;
  text-align: center;
  color: var(--text-soft);

  @media screen and (min-width: 1040px) {
    font-size: 0.875rem;
  }
}

.addAssetsButton {
  margin-top: 16px;
}

.small {
  min-height: 120px;
  padding: 16px;

  .styledImg {
    width: 60px;
    height: 60px;
  }

  .title {
    @include typography-v2-title-base;

    margin-bottom: 0;
    color: var(--text-default);
    text-align: center;
  }
}
